import React, { Component } from 'react';

export default class TransportSales extends Component {
    render() {
        return <h1>Sales</h1>;
    }
}



// WEBPACK FOOTER //
// ./src/modules/Transport/components/Sales/Sales.js